var _effectorFileName = "/src/page-content/login/components/login-form/login-form.tsx";
import { useRouter } from 'next/router';
import { zodResolver } from '@hookform/resolvers/zod';
import { useUnit } from 'effector-react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { ContactModal } from '@/shared/components/contact-modal';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/shared/components/ui/form';
import { Input } from '@/shared/components/ui/input';
import { EMAIL_NOT_VALID_MESSAGE, REQUIRED_FIELD_MESSAGE } from '@/shared/constants/error-messages';
import { loginDataSent } from './model';
const loginFormSchema = z.object({
  email: z.string().email({
    message: EMAIL_NOT_VALID_MESSAGE
  }).refine(value => !!value, {
    message: REQUIRED_FIELD_MESSAGE,
    path: []
  }),
  password: z.string().refine(value => !!value, {
    path: []
  })
});
export const LoginForm = () => {
  const router = useRouter();
  const {
    onLoginDataSent
  } = useUnit({
    onLoginDataSent: loginDataSent
  });
  const loginForm = useForm<z.infer<typeof loginFormSchema>>({
    resolver: zodResolver(loginFormSchema),
    mode: 'onSubmit',
    defaultValues: {
      email: '',
      password: ''
    }
  });
  const {
    formState,
    handleSubmit
  } = loginForm;
  const onSubmit = (values: z.infer<typeof loginFormSchema>) => {
    const {
      email,
      password
    } = values;
    onLoginDataSent({
      email,
      password,
      role: 'ADMIN'
    });
  };
  return <div className="w-full sm:max-w-[80%] md:max-w-[70%] lg:max-w-md">
      <TextGradient text="Логин" tag="h1" className="mb-6 text-center text-5xl sm:mb-4 sm:max-w-lg" />

      <Form {...loginForm}>
        <form onSubmit={handleSubmit(onSubmit)} className="max-w-5xl space-y-6">
          <FormField control={loginForm.control} name="email" render={({
          field
        }) => <FormItem className="flex flex-col">
                <FormLabel>E-mail</FormLabel>

                <FormControl>
                  <Input {...field} placeholder="E-mail..." />
                </FormControl>

                <FormMessage className="font-normal" />
              </FormItem>} />

          <FormField control={loginForm.control} name="password" render={({
          field
        }) => <FormItem className="flex flex-col">
                <FormLabel>Пароль</FormLabel>

                <FormControl>
                  <Input {...field} placeholder="Пароль..." type="password" />
                </FormControl>

                <FormMessage className="font-normal" />
              </FormItem>} />

          <div>
            <Button disabled={!formState.isValid || formState.isSubmitting} variant="cta" type="submit" className="block w-full tracking-wide">
              Войти
            </Button>
          </div>
        </form>
      </Form>

      <div className="relative mt-6">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t"></span>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">Нет аккаунта?</span>
        </div>
      </div>

      <ContactModal entryPoint="LOGIN_FORM">
        <Button variant="link" className="mt-2 w-full px-6" aria-label="Записаться на бесплатное занятие">
          Записаться на бесплатное занятие
        </Button>
      </ContactModal>
    </div>;
};